import React from "react";
import styles from "./FormPopUp.module.css";
import { createPortal } from "react-dom";

function FormPopUp({ message, button, onClose }) {
  return createPortal(
    <div className={styles.result}>
      <p className={styles.message}>{message}</p>
      <button onClick={() => onClose(false)} className={styles.button}>
        {button}
      </button>
    </div>,
    document.getElementById("portal")
  );
}

export { FormPopUp };
